import { SpaceVertical } from '@looker/components';
import { BIIncludeExclude, type IncludeExcludeState } from '@pulsepointinc/bi-components';
import type { StateKey } from '@pulsepointinc/bi-components/dist/components/BIIncludeExclude/IncludeExclude.type';
import { type FC, useRef } from 'react';
import { BulkUpdateSection } from './BulkUpdateSection';
import type { Mode } from './hooks/useIncludeExcludeFilter';

interface SelectedOnlySectionProps {
  mode: Mode;
  state: IncludeExcludeState;
  selected: string[];
  onChange: (state: IncludeExcludeState) => void;
  render?: (category: string, state?: StateKey | 'semi-check' | 'semi-block') => React.ReactNode;
}

export const SelectedOnlySection: FC<SelectedOnlySectionProps> = ({ mode, state, selected, onChange, render }) => {
  const initialSelected = useRef(selected);

  return (
    <SpaceVertical height="100%" align="stretch" gap="u3" px="u6" py="u3">
      {initialSelected.current.length > 0 && (
        <BulkUpdateSection
          filterState={state}
          handleFilterChange={onChange}
          categories={initialSelected.current}
          mode={mode}
        />
      )}
      <BIIncludeExclude
        mode={mode}
        initialState={state}
        categories={initialSelected.current}
        onToggleChange={onChange}
        renderCategory={render}
      />
    </SpaceVertical>
  );
};
